import { Avatar, Button, Drawer } from "antd";
import { MenuOutlined, MoonOutlined, SunOutlined, UserOutlined } from "@ant-design/icons";
import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { BrandMark } from "../components/BrandMark";
import { BottomNav } from "../components/BottomNav";
import { NAV_ITEMS, SETTINGS_ITEM } from "../components/NavItems";
import { useColorMode } from "../theme/ThemeProvider";
import { useAuth } from "../hooks/useAuth";

export function MobileLayout() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { mode, toggle } = useColorMode();
  const { user, logout } = useAuth();

  return (
    <div
      style={{
        display: "grid",
        gridTemplateRows: "auto 1fr auto",
        height: "100dvh",
        background: "var(--ant-color-bg-layout)",
      }}
    >
      <header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
          padding: "10px 14px",
          paddingTop: "calc(env(safe-area-inset-top) + 10px)",
          background: "var(--ant-color-bg-container)",
          borderBottom: "1px solid var(--ant-color-border)",
        }}
      >
        <Button type="text" shape="circle" icon={<MenuOutlined />} onClick={() => setOpen(true)} />
        <BrandMark size={24} />
        <Button
          type="text"
          shape="circle"
          icon={mode === "dark" ? <SunOutlined /> : <MoonOutlined />}
          onClick={toggle}
        />
      </header>

      <main style={{ overflow: "auto" }}>
        <Outlet />
      </main>

      <BottomNav />

      <Drawer
        placement="left"
        width={280}
        open={open}
        onClose={() => setOpen(false)}
        title={<BrandMark />}
        styles={{ body: { padding: 8 } }}
      >
        {[...NAV_ITEMS, SETTINGS_ITEM].map((it) => (
          <button
            key={it.key}
            type="button"
            onClick={() => {
              navigate(it.to);
              setOpen(false);
            }}
            style={{
              width: "100%",
              minHeight: 48,
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "0 12px",
              border: "none",
              background: "transparent",
              color: "var(--ant-color-text)",
              fontSize: 17,
              fontWeight: 500,
              borderRadius: 8,
              cursor: "pointer",
            }}
          >
            <span style={{ fontSize: 20 }}>{it.icon}</span>
            <span>{it.label}</span>
          </button>
        ))}
        <div
          style={{
            marginTop: 16,
            padding: 12,
            display: "flex",
            alignItems: "center",
            gap: 12,
            borderTop: "1px solid var(--ant-color-border)",
          }}
        >
          <Avatar src={user?.pictureUrl ?? undefined} icon={<UserOutlined />} size={36} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 16, fontWeight: 500 }}>{user?.name ?? user?.email}</div>
            <div style={{ fontSize: 14, color: "var(--ant-color-text-secondary)" }}>
              {user?.email}
            </div>
          </div>
          <Button
            size="small"
            onClick={() => {
              void logout();
            }}
          >
            退出
          </Button>
        </div>
      </Drawer>
    </div>
  );
}
